import ClassNameExtendableHoC from 'components/Generic/ClassNameExtendableHoC';

import CheckboxLabel from './CheckboxLabel';

const CheckboxLabelSec = ClassNameExtendableHoC(CheckboxLabel, 'ds-checkbox__sec _single_');
const RatingBadge = ClassNameExtendableHoC(CheckboxLabel, 'ds-checkbox__sec _single_ badge');

export { CheckboxLabelSec, RatingBadge };
